<template>
  <div class="message-center-container">
    <van-nav-bar :title="$t('message_center')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="message-list">
        <div
          class="message-list-item"
          v-for="item in messageList"
          :key="item.id"
          @click="viewMessage(item)"
        >
          <div class="message-title">
            {{ item.title }}
          </div>
          <div class="message-time">
            {{ (item.created_at * 1000) | dateFormat("MM/dd/yyyy hh:mm:ss") }}
          </div>
          <div class="message-dot" v-if="item.status == 1"></div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" style="width: 80%" round>
      <div class="message-box">
        <div class="title">
          {{ messageDetail.title }}
        </div>
        <div class="time">
          {{
            (messageDetail.created_at * 1000)
              | dateFormat("MM/dd/yyyy hh:mm:ss")
          }}
        </div>
        <div class="message-content" v-html="messageDetail.content"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      messageList: [],
      messageDetail: "",
      show: false,
    };
  },
  async created() {
    await this.getMessageList();
  },
  methods: {
    async viewMessage(item) {
      if (item.status == 2) {
        this.messageDetail = item;
        this.show = true;
      } else {
        await this.readMessage(item.id);
        this.messageDetail = item;
        this.show = true;
      }
    },
    navBack() {
      this.$router.replace("/");
    },
    async getMessageList() {
      const res = await this.$api.getMessageList();
      if (res.code == 200) {
        this.messageList = res.data;
      }
    },
    async readMessage(id) {
      this.$Toast.loading({ duration: 0 })
      const res = await this.$api.readMessage({
        id,
      });
      this.$Toast.clear()
      if (res.code == 200) {
        this.getMessageList();
      } else {
        this.$Toast(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.message-center-container {
  .back {
    width: 30px;
    height: 15px;
  }
  .content {
    padding: 15px;
    .message-list {
      &-item {
        background: #fff;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 20px;
        box-shadow: 1px 3px 5px #ddd;
        position: relative;
        .message-title {
          font-size: 14px;
          font-weight: 600;
        }
        .message-time {
          margin-top: 10px;
          text-align: right;
          font-size: 12px;
          color: #999;
        }
        .message-dot {
          width: 5px;
          height: 5px;
          border-radius: 5px;
          background: red;
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
    }
  }
  .message-box {
    padding: 10px;
    .title {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }
    .time {
      font-size: 12px;
      color: #999;
      margin-top: 10px;
    }
    .message-content {
      font-size: 14px;
    }
  }
}
</style>